const PRODUCTION_HOSTNAMES = [
  'admin-shop.ginzaxiaoma.com',
  'admin.ginzaxiaoma.com',
];

export const isProductionEnvironment = () => {
  return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
};

export const isTestEnvironment = () => !isProductionEnvironment();
